<app-header></app-header>
<div class="container">
  <mat-expansion-panel hideToggle [disabled]="cargando" [expanded]="!cargando">
    <mat-expansion-panel-header>
      <mat-panel-title>Formulario UAF a completar</mat-panel-title>
        <div *ngIf="cargando">
          <div class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
    </mat-expansion-panel-header>
    <div class="txt-info-uaf mt-16">
      <p>
        A continuación puedes revisar el formulario UAF con los datos precargados, por favor, revisa y completa la
        información que falte.
      </p>
    </div>
    <img class="logo-uaf" src="assets/images/logo_uaf.jpg" alt="icon-uaf">
    <div class="titulo-uaf">
      <h4>DECLARACIÓN JURADA PARA LA IDENTIFICACIÓN DE BENEFICIARIOS FINALES DE PERSONAS Y/O ESTRUCTURAS JURÍDICAS</h4>
      <hr />
    </div>
    <div class="texto-bajada">
      <p>Las personas y estructuras jurídicas (PJ) que cumplan los requisitos dispuestos en la Circular Nº57/2017 de la
        Unidad de Análisis Financiero deberán proporcionar la siguiente información:</p>
    </div>
    <!--Inicio Sección 1-->
    <div id="antecedentes-persona">
      <p class="encabezado-form-auf">1.ANTECEDENTES DE LA PERSONA O ESTRUCTURA JURÍDICA DECLARANTE</p>
      <form [formGroup]="formAntecedentesPersona">
        <div class="row form-antecedentes-persona">
          <div class="col-md-4">
            <label for="rutEmpresa">RUT/N° identificación:</label>
            <input formControlName="rutEmpresa" type="text" name="rutEmpresa" appFormatRut placeholder="12.345.678-9"
              [class.inputInvalido]=" formAntecedentesPersona.get('rutEmpresa').invalid && formAntecedentesPersona.get('rutEmpresa').touched"
              [class.inputInvalido]="formAntecedentesPersona.get('rutEmpresa').invalid && (formAntecedentesPersona.get('rutEmpresa').touched || formAntecedentesPersona.get('rutEmpresa').dirty)">
          </div>
          <div class="col-md-8">
            <label for="razonSocial">Razón social:</label>
            <input formControlName="razonSocial" type="text" name="razonSocial">
          </div>
          <div class="col-md-6">
            <label for="domicilio">Domicilio:</label>
            <input formControlName="domicilio" type="text" name="domicilio">
          </div>
          <div class="col-md-2">
            <label for="ciudad">Ciudad:</label>
            <input appCaracteres formControlName="ciudad" type="text" name="ciudad">
          </div>
          <div class="col-md-4">
            <label for="paisConstitucion">País de constitución:</label>
            <input appCaracteres formControlName="paisConstitucion" type="text" name="paisConstitucion">
          </div>
          <div class="col-md-4">
            <label for="telefono">Teléfono:</label>
            <input appNumeros formControlName="telefono" type="text" name="telefono" maxlength="9">
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <hr />
          </div>
        </div>
        <div class="row form-antecedentes-persona">
          <div class="col-md-4">
            <label for="rutRepresentante">CNI/N° identificacion representate legal:</label>
            <input formControlName="rutRepresentante" type="text" name="rutRepresentante" appFormatRut
              placeholder="12.345.678-9"
              [class.inputInvalido]=" formAntecedentesPersona.get('rutRepresentante').invalid && formAntecedentesPersona.get('rutRepresentante').touched"
              [class.inputInvalido]="formAntecedentesPersona.get('rutRepresentante').invalid && (formAntecedentesPersona.get('rutRepresentante').touched || formAntecedentesPersona.get('rutRepresentante').dirty)">
          </div>
          <div class="col-md-8">
            <label for="nombreRepresentate">Nombre representate legal:</label>
            <input appCaracteres formControlName="nombreRepresentate" type="text" name="nombreRepresentate" maxlength="100">
          </div>
          <div class="col-md-4">
            <label for="tipoEntidad">Tipo entidad:</label>
            <select name="tipoEntidad" formControlName="tipoEntidad">
              <option value="Anónima">Anónima</option>
              <option value="Colectiva">Colectiva</option>
              <option value="En comandita">En comandita</option>
              <option value="Limitada">Limitada</option>
              <option value="EIRL">EIRL</option>
              <option value="Otra">Otra</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <hr />
          </div>
        </div>
      </form>
    </div>
    <!--Inicio Sección 2-->
    <div id="identificacion-beneficiarios">
      <p class="encabezado-form-auf">2.IDENTIFICACIÓN DE LOS BENEFICIARIOS FINALES</p>
      <p class="texto-bajada">Se entenderá como Beneficiarios Finales a la(s) persona(s) natural(es) que finalmente
        posee, directa o indirectamente, a través de sociedades u otros mecanismos,
        una participación igual o mayor al 10 % del capital o de los derechos a voto de una persona jurídica
        determinada. Asimismo, se entenderá como Beneficiario Final a la(s) persona(s)
        natural(es) que, sin perjuicio de poseer directa o indirectamente una participación inferior al 10% del capital
        o de los derechos a voto de una persona jurídica, a través de sociedades
        u otros mecanismos, ejerce el control efectivo de la persona o estructura jurídica.</p>
      <div id="tabla-beneficiario-final">
        <p>
          <strong>Beneficiarios Finales:</strong> Identifique las personas naturales que tienen una participación en la
          persona o estructura jurídica
          declarante igual o mayor al 10%.
        </p>
        <table class="table table-bordered">
          <tr>
            <th class="col-xs-1 text-center">CNI/ID</th>
            <th class="col-xs-2 text-center">Nombre Completo</th>
            <th class="col-xs-2 text-center">Domicilio</th>
            <th class="col-xs-2 text-center">Ciudad</th>
            <th class="col-xs-2 text-center">País</th>
            <th class="col-xs-1 text-center" style="font-size: 10px;">% Participación en la PJ declarante</th>
            <th class="col-xs-1"></th>
          </tr>
          <tr *ngFor="let beneficiario of beneficiariosFinalesList">
            <td class="text-center">{{beneficiario.rut}}</td>
            <td class="text-center">{{beneficiario.nombre}}</td>
            <td class="text-center">{{beneficiario.domicilio}}</td>
            <td class="text-center">{{beneficiario.ciudad}}</td>
            <td class="text-center">{{beneficiario.pais}}</td>
            <td class="text-center">{{beneficiario.participacion}}</td>
            <td class="text-center">
              <button class="btn-secondary-tbk mr-1" (click)="editarRegistroTabla(true, beneficiario)"><img class="c-icon" src="assets/icons/editar.png" alt="Editar" /></button>
              <button class="btn-secondary-tbk" (click)="eliminarRegistroTabla(true, beneficiario)"><img class="c-icon" src="assets/icons/icon-delete.svg" alt="Eliminar"/></button>
            </td>
          </tr>
          <tr>
            <td colspan="7">
              <button class="btn btn-primary" (click)="openModal(true, true)">
                <i class="fa fa-plus" aria-hidden="true"></i> Agregar Beneficiario Final
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div id="tabla-control-efectivo">
      <p>
        <strong>Control Efectivo:</strong> Identifique a las personas naturales que, sin perjuicio de poseer directa o
        indirectamente una participación inferior al 10%, ejerce el control efectivo de la persona o estructura jurídica
        declarante.
      </p>
      <table class="table table-bordered">
        <tr>
          <th class="col-xs-1 text-center">CNI/ID</th>
          <th class="col-xs-2 text-center">Nombre Completo</th>
          <th class="col-xs-2 text-center">Domicilio</th>
          <th class="col-xs-2 text-center">Ciudad</th>
          <th class="col-xs-2 text-center">País</th>
          <th class="col-xs-1 text-center" style="font-size: 10px;">% Participación en la PJ declarante</th>
          <th class="col-xs-1"></th>
        </tr>
        <tr *ngFor="let control of controlEfectivoList">
          <td class="text-center">{{control.rut}}</td>
          <td class="text-center">{{control.nombre}}</td>
          <td class="text-center">{{control.domicilio}}</td>
          <td class="text-center">{{control.ciudad}}</td>
          <td class="text-center">{{control.pais}}</td>
          <td class="text-center">{{control.participacion}}</td>
          <td class="text-center">
            <button class="btn-secondary-tbk mr-1" (click)="editarRegistroTabla(false, control)"><img  class="c-icon" src="assets/icons/editar.png" alt="Editar" /></button>
            <button class="btn-secondary-tbk" (click)="eliminarRegistroTabla(false, control)"><img class="c-icon" src="assets/icons/icon-delete.svg" alt="Eliminar"/></button>
        </tr>
        <tr>
          <td colspan="7">
            <button class="btn btn-primary" (click)="openModal(false, true)">
              <i class="fa fa-plus" aria-hidden="true, true"></i> Agregar Control Efectivo
            </button>
          </td>
        </tr>
      </table>
    </div>
    <!--Inicio Sección 3-->
    <div id="antecedentes-declarante">
      <p class="encabezado-form-auf">3. ANTECEDENTES DE LA PERSONA QUE REALIZA LA PRESENTE DECLARACIÓN</p>
      <form [formGroup]="formAntecedentesDeclarante">
        <div class="row form-antecedentes-declarante">
          <div class="col-md-12">
            <label for="nacionalidad">Nacionalidad</label>
            <mat-radio-group formControlName="nacionalidad" name="nacionalidad">
              <mat-radio-button name="Chilena" value="Chilena" class="radio-inline mr-63">Chilena
              </mat-radio-button>
              <mat-radio-button name="Extranjero residente" value="Extranjero residenten"
                class="radio-inline mr-63">
                Extranjero residente</mat-radio-button>
              <mat-radio-button name="Extranjero no residente" value="Extranjero no residente" class="radio-inline">
                Extranjero no residente</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-md-3">
            <label for="rutDeclarante">CNI/N° identificacion:</label>
            <input formControlName="rutDeclarante" type="text" name="rutDeclarante" appFormatRut
              placeholder="12.345.678-9" 
              [class.inputInvalido]=" formAntecedentesDeclarante.get('rutDeclarante').invalid && formAntecedentesDeclarante.get('rutDeclarante').touched"
              [class.inputInvalido]="formAntecedentesDeclarante.get('rutDeclarante').invalid && (formAntecedentesDeclarante.get('rutDeclarante').touched || formAntecedentesDeclarante.get('rutDeclarante').dirty)">
          </div>
          <div class="col-md-3">
            <label for="nombreDeclarante">Nombres:</label>
            <input appCaracteres formControlName="nombreDeclarante" type="text" name="nombreDeclarante" maxlength="50">
          </div>
          <div class="col-md-3">
            <label for="apellidoPaterno">Apellido Paterno:</label>
            <input appCaracteres formControlName="apellidoPaterno" type="text" name="apellidoPaterno" maxlength="30">
          </div>
          <div class="col-md-3">
            <label for="apellidoMaterno">Apellido Materno:</label>
            <input appCaracteres formControlName="apellidoMaterno" type="text" name="apellidoMaterno" maxlength="30">
          </div>
          <div class="col-md-5">
            <label for="lugarOrigen">Lugar de Origen:</label>
            <input appCaracteres formControlName="lugarOrigen" type="text" name="lugarOrigen">
          </div>
          <div class="col-md-7">
            <label for="relacionDeclarante">Relación con la persona jurídica declarante:</label>
            <input appCaracteres formControlName="relacionDeclarante" type="text" name="relacionDeclarante">
          </div>
        </div>
      </form>

      <p>Declaro bajo juramento, que la información proporcionada en este formulario es completa y veraz.</p>
      <p> {{txtFecha}}</p>
    </div>
    <div class="row">
      <div class="col-md-6 ">
          <input class="btn-secondary-tbk btn-volver" type="button" value="Volver" [disabled]="cargando || guardando" (click)="volver()">
      </div>
      <div class="col-md-6">
          <button class="btn-primary-tbk" value="Guardar" [disabled]="cargando" (click)="saveDeclaracion()">
            <div *ngIf="guardando" class="spinner-border text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div *ngIf="!guardando">Guardar</div>           
          </button>
      </div>
    </div>
  </mat-expansion-panel>
  
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{tituloModal}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
            aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formModal">
          <div class="row form-modal">
            <div class="col-md-12">
              <label for="rutModal">CNI/ID:</label>
              <input formControlName="rutModal" type="text" name="rutModal" appFormatRut placeholder="12.345.678-9"
              [class.inputInvalido]=" formModal.get('rutModal').invalid && formModal.get('rutModal').touched"
              [class.inputInvalido]="formModal.get('rutModal').invalid && (formModal.get('rutModal').touched || formModal.get('rutModal').dirty)">
            </div>
            <div class="col-md-12">
              <label for="nombreModal">Nombres:</label>
              <input appCaracteres formControlName="nombreModal" type="text" name="nombreModal" maxlength="100">
            </div>
            <div class="col-md-12">
              <label for="domicilioModal">Domicilio:</label>
              <input formControlName="domicilioModal" type="text" name="domicilioModal" maxlength="100">
            </div>
            <div class="col-md-12">
              <label for="ciudadModal">Ciudad:</label>
              <input appCaracteres formControlName="ciudadModal" type="text" name="ciudadModal">
            </div>
            <div class="col-md-12">
              <label for="paisConstitucion">País de constitución:</label>
              <input appCaracteres formControlName="paisConstitucion" type="text" name="paisConstitucion">
            </div>
            <div class="col-md-12">
              <label for="participacionModal">% participación:</label>
              <input appNumeros formControlName="participacionModal" type="text" name="participacionModal" (keyup)="validateParticipacion('participacionModal')" >
              <span [hidden]="participacionBeneficiarioOk">La participación del Beneficiario debe estar entre 10% y 100%</span>
              <span [hidden]="participacionControlOk">La participación de Control Efectivo debe estar entre 1% y 9%</span>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button [disabled]="validaModalData()" [hidden]="!isBeneficiario" type="button" class="btn-primary-tbk"
          (click)="addBeneficiario()">Guardar</button>
        <button [disabled]="validaModalData()" [hidden]="isBeneficiario" type="button" class="btn-primary-tbk"
          (click)="addControlEfectivo()">Guardar</button>
      </div>
    </div>
  </div>
</div>